import React from 'react';
import { GroupTag } from '../types/protocols';
import { iconForGroupTag } from '../types/BuildingTypeEnums';
import LabelTag from '../MapOverview/LabelTagComponent';

interface BuildingGroupTagsProps {
    groupTags?: { [key: string]: GroupTag };
    marginBottom?: number;
}

/**
 * Renders a building's group tags as chips, matching the map popup style.
 * Returns null when there are no tags so callers can drop it inline safely.
 */
export const BuildingGroupTags: React.FC<BuildingGroupTagsProps> = ({ groupTags, marginBottom = 0 }) => {
    const tags = groupTags ? Object.values(groupTags) : [];
    if (tags.length === 0) {
        return null;
    }

    return (
        <>
            {tags.map((tag, index) => (
                <LabelTag
                    key={`${tag.key ?? tag.tag}-${index}`}
                    text={tag.tag}
                    backgroundColor="#F2F2F2"
                    textColor="#000"
                    marginBottom={marginBottom}
                    imgSrc={iconForGroupTag(tag.tag)}
                />
            ))}
        </>
    );
};
